import { type UseFormRegisterReturn } from "react-hook-form";
import tw from "twin.macro";
import React from "react";
import { FieldError } from "~/features/ui/form/field-error";

type Props = {
  label?: string;
  error?: string;
  register?: UseFormRegisterReturn;
};

const style = tw`
  h-full w-full text-mobile-body-30-normal lg:text-desktop-body-30-normal min-h-[164px] bg-white-100-light
  p-16 border-b border-b-grey-40-light rounded-2 text-black-80-light appearance-none
  disabled:(pointer-events-none bg-black-transparent-20-dark text-grey-50-dark)
`;

export const TextArea = React.forwardRef<HTMLTextAreaElement, Props & React.ComponentPropsWithRef<"textarea">>(
  (props, ref) => {
    const { label, error, register, ...rest } = props;

    return (
      <label htmlFor={rest.name} css={[tw`flex flex-col w-full`, rest.disabled && tw`pointer-events-none`]}>
        {label && (
          <span tw="font-aeonik text-mobile-caption-30-normal lg:text-desktop-caption-30-normal text-grey-100-light mb-16 block">
            {label}
            {rest.required && <span tw="text-blue-100 ml-8">*</span>}
          </span>
        )}
        <div tw="relative flex">
          <textarea
            rows={1}
            ref={ref}
            aria-invalid={Boolean(Error) ? "true" : "false"}
            css={[style, Boolean(error) && tw`text-error placeholder-error border-error`]}
            {...register}
            {...rest}
          />
          {error && <FieldError message={error} />}
        </div>
      </label>
    );
  }
);
